import { Component, OnInit } from '@angular/core';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { realEstateLocationDurationOptions } from '@app/forms/subscription/services/ref';

@Component({
    selector: 'real-estate-pinel-parameters',
    templateUrl: './real-estate-pinel-parameters.component.html',
    styleUrls: ['./real-estate-pinel-parameters.component.scss'],
    standalone: false
})
export class RealEstatePinelParametersComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  realEstateLocationDurationOptions = realEstateLocationDurationOptions;
  constructor(
    protected formConstructor: PrFormConstructor,

    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
